<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter" id="c03"><a id="page03"></a>A Clique Come True</h1>
<p class="nonindent"><span class="dropcaps">I</span>n January 1996, Stewart Marshall was found guilty of assaulting his wife. After announcing the verdict, Judge Joel Gehrke called Marshall to the bench and ordered him to hold out his hand. Marshall did as he was told, and Judge Gehrke gave him a light, three-fingered slap on the wrist and admonished him by saying, “Don’t do that!” This action started a whirlwind of public outrage against the judge, but Gehrke felt the simple punishment was justified since Marshall’s wife had become pregnant by Marshall’s brother and recently given birth to Marshall’s nephew.<img alt="" src="OEBPS/images/Greg_9780740792069_epub_L04_r1.jpg"/></p>
<div class="block">
<p class="center"><img alt="" src="OEBPS/images/Greg_9780740792069_epub_L07_r1.jpg"/></p>
<p class="center02">The ancient Egyptians used <strong><span class="big01">crocodile dung</span></strong> as a contraceptive. [Author’s note: I can see how that would work, can’t you?] But it was the use of the acacia plant that yielded the best results. Even today, the active ingredients in the acacia plant are found in spermicidal jellies and creams.</p>
<p class="center">—<em>The History of Sex</em>, the History Channel, August 1999</p>
<p class="center"><img alt="" src="OEBPS/images/Greg_9780740792069_epub_L07_r1.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740792069_epub_c03_r1.vue?50c16ebc